import { createContext } from "react";

export const PortalCtx = createContext<HTMLElement | null>(null);

export function PortalProvider({
  container,
  children,
}: {
  container: HTMLElement;
  children: React.ReactNode;
}) {
  return <PortalCtx.Provider value={container}>{children}</PortalCtx.Provider>;
}
